<template>
  <div>
    <div @click="reqExData">物流信息</div>

    <div
      class="express-content"
      v-if="isShow && exData"
      @click="
        () => {
          isShow = false
          exData = null;
        }
      "
    >
      <p class="express-code">
        {{ exData.expressInc }} {{ exData.expressCode }}（单击页面关闭）
      </p>

      <div class="express-item" v-for="(item, index) in exData.items" :key="index">
        <div class="express-time">{{item.ftime}}</div>
        <div class="express-text">{{item.context}}</div>
        <div class="express-circle"></div>
        <div class="express-line"></div>
      </div>

      <p class="express-footer" v-if="!exInfo" @click="() => { exData = null; }">
        修改物流单号
      </p>
    </div>

    <div class="express-input" v-if="isShow && !exData">
      <div class="page page__has-bar">
        <div class="weui-cells">
          <div class="weui-cell weui-cell_active">
            <div class="weui-cell__hd">
              <label for class="weui-label">物流公司</label>
            </div>
            <div class="weui-cell__bd">
              <input
                v-model="expressInc"
                @focus="focus"
                class="weui-input weui-search-box__input"
                ref="input"
              />
            </div>
          </div>
          <div class="weui-cells weui-search-result" v-if="showSelect">
            <div v-for="(item, index) in express" :key="index">
              <div
                class="weui-cell weui-cell_active weui-cell_access"
                v-if="!expressInc || item.label.indexOf(expressInc) !== -1"
                @click="onSelect(index)"
              >
                <div class="weui-cell__hd">{{item.label}}</div>
                <div class="weui-cell__bd"></div>
                <div class="weui-cell__ft"></div>
              </div>
            </div>
          </div>
          <div class="weui-cell weui-cell_active">
            <div class="weui-cell__hd">
              <label for class="weui-label">物流单号</label>
            </div>
            <div class="weui-cell__bd">
              <input class="weui-input" type="text" v-model="expressCode"/>
            </div>
          </div>
        </div>
        <div class="footer-bar weui-dialog__ft">
          <a
            href="javascript:;"
            class="weui-dialog__btn weui-dialog__btn_primary"
            @click="save"
            >确定</a
          >
          <a
            href="javascript:;"
            class="weui-dialog__btn weui-dialog__btn_default"
            @click="() => { isShow = false }"
            >取消</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import express from "@/assets/json/express"

export default {
  props: {
    exInfo: Object,
    bizId: Number,
    bizType: String,
    bizCode: String
  },
  data() {
    return {
      isShow: false,
      exData: null,
      express,
      showSelect: false,
      expressCode: null,
      expressInc: null,
      expressIncCode: null
    };
  },
  methods: {
    reqExData() {
      var me = this;
      if(me.exInfo) {
        me.exData = me.exInfo
        me.isShow = true
        return
      }
      me.$loading({
        url: "/api/express/read",
        params: {
          bizType: me.bizType,
          bizId: me.bizId
        }
      }).then(function (res) {
        if (res.success) {
          me.isShow = true
          me.exData = res.data
        } else {
          me.$weui.topTips(res.message || "请求物流信息失败", 3000);
        }
      });
    },
    onSelect(index) {
      this.expressInc = this.express[index].label
      this.expressIncCode = this.express[index].value
      this.showSelect = false;
    },
    focus() {
      this.showSelect = true
    },
    save() {
      var me = this;
      if(!me.expressInc || !me.expressCode) {
        me.$weui.topTips("请完整输入物流信息", 3000);
        return
      }
      me.$loading({
        url: "/api/express/save",
        method: "POST",
        jsonData: {
          bizType: me.bizType,
          bizCode: me.bizCode,
          bizId: me.bizId,
          expressCode: me.expressCode,
          expressInc: me.expressInc,
          expressIncCode: me.expressIncCode
        }
      }).then(function (res) {
        if (res.success) {
          me.isShow = true
          me.exData = res.data
        } else {
          me.$weui.topTips(res.message || "请求物流信息失败", 3000);
        }
      });
    }
  },
};
</script>

<style scoped>
.express-content {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  padding: 0 10px 50px 10px;
  box-sizing: border-box;
  overflow-y: scroll;
  line-height: normal;
  text-align: left;
  font-size: 16px;
  font-weight: 400;
  z-index: 500;
  color: var(--weui-FG-1);
  background: var(--weui-BG-2);
}
.express-code {
  margin-top: 10px;
  width: 100%;
  height: 50px;
  text-align: center;
  line-height: 50px;
  font-weight: 600;
}
.express-item {
  margin-bottom: 20px;
  position: relative;
  padding: 0 20px 20px 50px;
}
.express-item:first-of-type {
  font-weight: 900;
  color: var(--weui-TEXTGREEN);
}
.express-item:last-of-type {
  margin-bottom: 0;
}
.express-circle{
  width: 18px;
  height: 18px;
  border: 1px solid;
  border-radius: 50%;
  position: absolute;
  top: 0px;
  left: 11px;
}
.express-line{
  width: 1px;
  height: 100%;
  background: #999999;
  position: absolute;
  top: 20px;
  left: 20px;
}
.express-item:last-of-type .express-line {
  display: none;
}
.express-footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 50px;
  text-align: center;
  line-height: 50px;
  color: var(--weui-LINK);
  background-color: var(--weui-BG-3);
  overflow-x: scroll;
}

.express-input {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 500;
  font-weight: 400;
  background: var(--weui-BG-1);
}
.weui-search-result {
  background-color: var(--weui-BG-1);
  max-height: 300px;
  overflow-y: auto;
}
</style>